import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'hooks';
import { useAuthBackground } from '../../hooks/useAuthBackground';
import Link from 'components/ui/link';
import PrivacyLinks from 'pages/app/components/policyLinks';
import { RootState } from 'store';
import './pageAuthLegacy.scss';
import classNames from 'classnames';
import { resolveWlValue } from 'helpers/wlResolver';
interface Props {
  title: string;
  text?: string;
  subtext?: string;
  layout?: 'split' | 'center';
  children: React.ReactNode;
}

const PageAuthWrapperLegacy: React.FC<Props> = ({
  title,
  text = '',
  subtext = '',
  layout = 'split',
  children,
}) => {
  const getTranslate = useTranslation();
  const backgroundImage = useAuthBackground();
  const isCenteredForm = layout === 'center';

  const {
    brandConfig: {
      config: {
        assets: { logoUrl, logoLightUrl },
      },
    },
    visibleLegalLink,
    wlId,
  } = useSelector((state: RootState) => state.settings);
  const copyrightInfo = resolveWlValue(wlId, (config) => config.copyright, '');
  const renderPageAuthBanner = () => {
    return (
      <div
        className='page-auth__col page-auth__col-banner'
        style={{
          backgroundImage,
        }}>
        <div className='page-auth__header-mobile'>
          {logoLightUrl ? (
            <Link url='/login' className='page-auth__logo'>
              <img
                src={logoLightUrl}
                alt='logo'
                className='page-auth__logo-pic'
              />
            </Link>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <div className='page-auth'>
      <div className='page-auth__inner'>
        <div
          className={classNames(
            { 'page-auth__col-form-center': isCenteredForm },
            'page-auth__col page-auth__col-form'
          )}>
          <div className='page-auth__col-inner'>
            {logoUrl ? (
              <div className='page-auth__header'>
                <Link url='/login' className='page-auth__logo'>
                  <img
                    src={logoUrl}
                    alt='logo'
                    className='page-auth__logo-pic'
                  />
                </Link>
              </div>
            ) : null}
            <div className='page-auth__main'>
              <div className='page-auth__main-header'>
                <h1 className='page-auth__title'>{getTranslate(title)}</h1>
              </div>
              {text ? (
                <div className='page-auth__text'>{getTranslate(text)}</div>
              ) : null}
              {subtext ? (
                <div className='page-auth__text'>{getTranslate(subtext)}</div>
              ) : null}
              {children}
            </div>
            {visibleLegalLink ? (
              <div className='page-auth__footer'>
                <PrivacyLinks />
                {
                  copyrightInfo ? (
                    <span className='page-auth__footer-copyright'>
                      {copyrightInfo}
                    </span>
                  ) : null
                }
              </div >
            ) : null}
          </div >
        </div >
        {!isCenteredForm && renderPageAuthBanner()}
      </div >
    </div >
  );
};

export { PageAuthWrapperLegacy };
